import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import chat from './modules/chat';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth, chat
  },
  plugins: [createPersistedState({paths:["auth"]})]
});